module.exports = __webpack_public_path__ + "static/img/adoption_movie_thum_03_no_btn.ad28571.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/movie/adoption_movie_thum_03_no_btn.jpg
// module id = u+KW
// module chunks = 0